import { render, staticRenderFns } from "./DataEmployee.vue?vue&type=template&id=82263638&scoped=true&"
import script from "./DataEmployee.vue?vue&type=script&lang=js&"
export * from "./DataEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DataEmployee.vue?vue&type=style&index=0&id=82263638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82263638",
  null
  
)

export default component.exports